import { WHATSAPP_NUMBER, WHATSAPP_MESSAGE } from "../data/eventData";

export default function WhatsAppButton() {
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-floating-button"
      className="fixed z-50 bottom-20 right-4 sm:bottom-6 sm:right-6 group"
      aria-label="Falar pelo WhatsApp"
    >
      <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] shadow-[0_10px_30px_rgba(37,211,102,0.45)] ring-2 ring-[#25D366]/40 transition-all duration-300 group-hover:scale-110 group-hover:bg-[#1FBA57]">
        <span className="absolute inset-0 rounded-full bg-[#25D366]/40 animate-ping" />
        <svg viewBox="0 0 24 24" width="26" height="26" fill="currentColor" className="relative text-white">
          <path d="M19.05 4.91A10 10 0 0 0 12 2a10 10 0 0 0-8.59 15.07L2 22l5.05-1.32A10 10 0 1 0 19.05 4.91Zm-7.05 15.4a8.34 8.34 0 0 1-4.25-1.16l-.3-.18-3 .79.8-2.92-.2-.31A8.36 8.36 0 1 1 12 20.31Zm4.6-6.27c-.25-.13-1.5-.74-1.73-.83s-.4-.13-.57.13-.65.83-.8 1-.3.19-.55.06a6.85 6.85 0 0 1-2-1.24 7.55 7.55 0 0 1-1.4-1.74c-.15-.25 0-.39.11-.51s.25-.3.37-.45a1.5 1.5 0 0 0 .25-.41.46.46 0 0 0 0-.43c-.06-.13-.57-1.37-.78-1.88s-.41-.42-.57-.43h-.49a.94.94 0 0 0-.68.31 2.85 2.85 0 0 0-.89 2.12 4.94 4.94 0 0 0 1 2.61 11.32 11.32 0 0 0 4.31 3.81 14.7 14.7 0 0 0 1.44.53 3.46 3.46 0 0 0 1.59.1 2.6 2.6 0 0 0 1.71-1.21 2.12 2.12 0 0 0 .15-1.21c-.06-.11-.22-.17-.47-.29Z" />
        </svg>
      </span>
    </a>
  );
}
